module.exports = __webpack_public_path__ + "media/typy/rolnicze@2x-25bc6def.png";